import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class AddPaymentDetailsBuilder {
  constructor() {}

  buildFormControl(paymentDetails: string): FormControl {
    return new FormControl(paymentDetails, Validators.maxLength(1000));
  }
}
